<router-outlet></router-outlet>
<lowgile-quick-actions-container></lowgile-quick-actions-container>
<lowgile-global-search></lowgile-global-search>
